import NewShipmentForm from './NewShipmentForm'
import NewShipmentAccordion from './NewShipmentAccordion'
import ShipmentAccordionSummary from './ShipmentAccordionSummary'

NewShipmentAccordion.NewShipmentForm = NewShipmentForm
NewShipmentAccordion.ShipmentAccordionSummary = ShipmentAccordionSummary

export default NewShipmentAccordion
